import React from 'react'

import styles from './style.module.scss'

export interface ProductListLoan {
	id: number
	title: React.ReactNode
	description: React.ReactNode[]
}

interface ItemDescriptionProps {
	item: ProductListLoan
}

export const ItemDescription = ({ item }: ItemDescriptionProps) => {
	const rows = item.description.map((elem, index) => {
		return (
			<span key={index} className={styles.slim}>
				{elem}
			</span>
		)
	})

	return (
		<li className={styles.product}>
			<h3 className={styles.h3}>{item.title}</h3>
			<p className={styles.items}>{rows}</p>
		</li>
	)
}
